import {
  GET_ROLES,
} from 'constants/roles';

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_ROLES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
